import React from 'react'

import { Box } from '@material-ui/core'
import whatsNewPageStyles from './WhatsNewPageStyle'
import WhatsNewItemList from './components/itemList/WhatsNewItemList'
import { useTitle } from '../../../../navigation/helpers/useTitle'
const WhatsNewPage = () => {
  useTitle('My Rutgers New Features')
  const classes = whatsNewPageStyles()
  return (
    <Box className={classes.root}>
      <WhatsNewItemList />
    </Box>
  )
}

export default WhatsNewPage
